import { Dropdown } from '../ui/Dropdown';
import { DATE_PRESET_OPTIONS, type DateFilterValue } from './constants';
import { localDateStr } from './dateHelpers';

const RANGE_OPTION = { value: 'range', label: 'Диапазон' };
const ALL_OPTIONS = [...DATE_PRESET_OPTIONS, RANGE_OPTION];

export interface DateFilterControlProps {
  value: DateFilterValue;
  onChange: (v: DateFilterValue) => void;
  placeholder: string;
  size?: 'sm' | 'md';
}

export function DateFilterControl({
  value,
  onChange,
  placeholder,
  size = 'md',
}: DateFilterControlProps) {
  const selected =
    value === null ? [] :
    value.type === 'preset' ? [value.key] :
    ['range'];

  const handleDropdownChange = (next: string[]) => {
    const key = next[0];
    if (!key) {
      onChange(null);
      return;
    }
    if (key === 'range') {
      // Default the custom range to today–today if we're entering range mode fresh.
      if (value?.type !== 'range') {
        const today = localDateStr(0);
        onChange({ type: 'range', from: today, to: today });
      }
      return;
    }
    onChange({ type: 'preset', key });
  };

  const from = value?.type === 'range' ? value.from : '';
  const to = value?.type === 'range' ? value.to : '';

  const updateRange = (nextFrom: string, nextTo: string) => {
    onChange({ type: 'range', from: nextFrom, to: nextTo });
  };

  const inputCls =
    'bg-surface border border-border rounded-lg text-sm text-foreground px-2 py-1.5 hover:border-foreground-muted focus:outline-none focus:border-ctp-blue';

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <Dropdown
        size={size}
        options={ALL_OPTIONS}
        selected={selected}
        onChange={handleDropdownChange}
        placeholder={placeholder}
      />
      {value?.type === 'range' && (
        <>
          <input
            type="date"
            value={from}
            max={to || undefined}
            onChange={e => updateRange(e.target.value, to)}
            className={inputCls}
            aria-label={`${placeholder}: с`}
          />
          <span className="text-xs text-foreground-muted">—</span>
          <input
            type="date"
            value={to}
            min={from || undefined}
            onChange={e => updateRange(from, e.target.value)}
            className={inputCls}
            aria-label={`${placeholder}: по`}
          />
        </>
      )}
    </div>
  );
}

export default DateFilterControl;
